$(function() {

	"use strict";

	for (var key in basisMenuSetup) {
		$('#side-menu').append( "<li><a class='waves-effect ebs-href' href='#"+ key +"'>"+ basisMenuSetup[key] +"</a></li>" );
	}

	var url = window.location;
	var sdHash = url.hash.replace('#','');

	if(basisMenuSetup[sdHash] === undefined ){
		sdHash = basisDefaultForm;
	}
	loadForm(sdHash);

	$("#side-menu").on("click", "a", function(){
		var sdHash = this.hash;
		$('#side-menu a').removeClass('active').parent().removeClass('active');
			loadForm(sdHash);
	});


	function loadForm(sdHash){
		var htmlForm = sdHash.replace('#','');

		var element = $('#side-menu a').filter(function() {
			return this.hash == "#"+htmlForm;
		}).addClass('active').parent().addClass('active');

		while (true) {
			if (element.is('li')) {
				element = element.parent().addClass('in').parent().addClass('active');
			} else {
				break;
			}
		}

		var heightForm = 0;
		if(basisMenuSetup[htmlForm] !== undefined ){
			$("#sd-wrap-form").load("/static/forms/"+ htmlForm, function(){
				var heightForm = $("#sd-wrap-form").innerHeight() - 1;
				
				var curHeight = $(this).height(),
				    autoHeight = $(this).css('height', 'auto').innerHeight();
				$(this).height(curHeight).animate({height: autoHeight}, 300);

				var PageWrapperHeight = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
				var heightSidebar = $(".sidebar").innerHeight() - 1;
				if (heightSidebar > PageWrapperHeight) {
					PageWrapperHeight = heightSidebar;
				}
				var ebsHeight = PageWrapperHeight - autoHeight - 90;
				if(ebsHeight < 200){
					PageWrapperHeight = PageWrapperHeight + ebsHeight;
					ebsHeight = 200;
				}

				$("#ebs-textarea").height(ebsHeight);

				var watchRequest = $("#sd-wrap-form").find("form:first").attr('action');
				$("#watch-request").val(watchRequest);
			});
			$("textarea.ebs-textarea").val('');
		}

	}
}(jQuery, window, document));